const UNIT_CATEGORIES = {
  other: [
    'BSC',
    'BSU',
    'CSO',
    'DSO',
    'HOT',
    'ITO',
    'LND',
    'LSC',
    'PSU',
    'REI',
    'SSC',
  ],
  CFU: ['CDC', 'DT'],
  CMP: ['CSC', 'STO'],
  office: ['DSU', 'OFB', 'SO'],
  meetingPlace: ['SHC'],
};

export const getUnitCategory = (businessUnit) => {
  const unit = businessUnit.replace(/\d+/g, '');
  for (const [category, units] of Object.entries(UNIT_CATEGORIES)) {
    if (units.includes(unit)) {
      return category;
    }
  }
  return '';
};
